import React from "react";
import Info from "components/chrome/main_view/info";
import SupportChat from "components/chrome/main_view/support_chat";

// Shown when a Group Management URL is opened by an account that isn't provisioned
// for it (deep links included — e.g. a bookmark shared by a colleague at a
// rolled-out brand). Names the exact LaunchDarkly flags so provisioning and
// support can act on it directly.
type GroupManagementFlagsMissingInfoProps = {
  missingFlags: string[];
};

export default function GroupManagementFlagsMissingInfo({
  missingFlags,
}: GroupManagementFlagsMissingInfoProps) {
  return (
    <Info title="Group Management isn't enabled for your account yet.">
      <p>
        This page requires the following feature{" "}
        {missingFlags.length === 1 ? "flag" : "flags"} to be enabled for your
        brand:
      </p>
      <ul>
        {missingFlags.map((flag) => (
          <li key={flag}>
            <code>{flag}</code>
          </li>
        ))}
      </ul>
      <p>
        Please contact Upserve support to get set up — our support team is here
        24/7/365 to help.
      </p>
      <p>
        For assistance chat with us at <SupportChat />.
      </p>
    </Info>
  );
}
